<template>
  <div class="ui-detail-ctrl-wrapper" v-if="btnArr.length > 0">
    <div class="btn-wrapper btn-bar" v-if="isRenderBtnBar">
      <component
        :is="renderBtnCtrl()"
        :worksId="worksId"
        :hasPraised="hasPraised"
        :praiseNum="praiseNum"
        @resfresPraise="handlePraise"
        @refreshLogin="handleRefreshWorkList"
        @backPraise="handleBackPraise"
        @jumpContribute="handleJumpContribute"
        @shareWorkDetail="handleShareWorkDetail"
      />
    </div>
    <div class="btn-wrapper" v-else>
      <component
        v-for="item in btnArr"
        :key="item.renderFunc"
        :is="renderBtn(item.renderFunc)"
        :worksId="worksId"
        :hasPraised="hasPraised"
        :praiseNum="praiseNum"
        @resfresPraise="handlePraise"
        @refreshLogin="handleRefreshWorkList"
        @backPraise="handleBackPraise"
        @jumpContribute="handleJumpContribute"
        @shareWorkDetail="handleShareWorkDetail"
      ></component>
    </div>
  </div>
</template>

<script>
import BtnPraise from "./BtnPraise"
import BtnShare from "./BtnShare"
import BtnContribute from "./BtnContribute"
import BtnCtrl from "./BtnCtrl"
import { mapGetters } from "vuex"

export default {
  name: "uiDetailCtrl",
  props: {
    worksId: {
      type: [String, Number],
      default: ""
    },
    hasPraised: {
      type: Boolean,
      default: false
    },
    praiseNum: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handlePraise() {
      this.$emit("resfresPraise")
    },
    handleBackPraise() {
      this.$emit("backPraise")
    },
    handleRefreshWorkList() {
      this.$emit("refreshLogin")
    },
    handleJumpWorksList() {
      this.$emit("jumpWorksList")
    },
    handleShareWorkDetail() {
      this.$emit("shareWorkDetail")
    },
    handleJumpContribute() {
      this.$emit("jumpContribute")
    },
    renderBtnPraise() {
      return BtnPraise
    },
    renderBtnShare() {
      return BtnShare
    },
    renderBtnContribute() {
      return BtnContribute
    },
    renderBtnCtrl() {
      return BtnCtrl
    },
    renderBtn(renderFuncKey) {
      return this[renderFuncKey]()
    }
  },
  components: {
    BtnPraise,
    BtnShare,
    BtnContribute,
    BtnCtrl
  },
  computed: {
    ...mapGetters({
      contributeStatus: "activityInfo/contributeStatus",
      systemInfo: "systemInfo",
      hidePraise: "activityInfo/hidePraise"
    }),
    btnArr() {
      const isNfPlus = this.systemInfo.isNfPlus
      return [
        // {
        //   renderFunc: "renderBtnContribute",
        //   status: this.contributeStatus
        // },
        {
          renderFunc: "renderBtnPraise",
          status: !this.hidePraise
        },
        {
          renderFunc: "renderBtnShare",
          status: isNfPlus
        }
      ].filter(item => item.status)
    },
    isRenderBtnBar() {
      return this.btnArr.length === 3
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-detail-ctrl-wrapper {
  height: 1.12rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #ef3a31;
  letter-spacing: 0;
  text-align: center;
  .btn-wrapper {
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    ::v-deep .ui-btn {
      margin-right: 0.2rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .left,
  .right {
    width: 3rem;
    height: 100%;
    background: url("../../../../assets/images/sharepage_btn_bg.png") no-repeat center;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &:active {
      opacity: 0.7;
    }
  }
  .left {
    margin-right: 0.2rem;
    .icon-work {
      margin-right: 0.08rem;
      width: 0.44rem;
      height: 0.44rem;
      background: url("../../../../assets/images/sharepage_icon_works.png") no-repeat center;
      background-size: 100%;
    }
  }
  .right {
    .praise-wrapper {
      background-size: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .heart-wrapper {
        margin-right: 0.08rem;
        width: 0.44rem;
        height: 0.44rem;
        position: relative;
      }
      .icon-heart {
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        width: 100%;
        height: 100%;
        background: url("../../../../assets/images/sharepage_icon_like_n.png") no-repeat center;
        background-size: 100%;
        &.active {
          background: url("../../../../assets/images/sharepage_icon_like_s.png") no-repeat center;
          background-size: 100%;
        }
      }
    }
  }
}
.fade-toggle-enter-active {
  animation: toggleScale 0.3s ease-in-out;
}
.fade-toggle-leave-active {
  transition: opacity 0.3s;
}
.fade-toggle-leave {
  opacity: 1;
}
.fade-toggle-leave-to {
  opacity: 0;
}
@keyframes toggleScale {
  0% {
    transform: scale3d(0.6, 0.6, 1);
    opacity: 0.3;
  }
  75% {
    transform: scale3d(1.2, 1.2, 1);
    opacity: 1;
  }
  100% {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}
</style>
